<template>
  <v-row justify="center">
  <v-dialog
    v-model="showDialog"
    persistent max-width="700"
    :close-on-content-click="false"
    offset-x
  >
    <v-card flat>
      <v-toolbar
        :color="selectedTaskColor"
        flat
      >
        <v-toolbar-title style="color: #ffffff; font-weight: 500;" v-html="`WO#-${this.task.name}`"></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" style="margin-right: 1px;" icon class="text-right ml-3" @click="toggle">
          <v-icon color="#ffffff" size="32">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div class="flex-grow-1"></div>
         <v-col cols="12" sm="12" style="height:35px">
          Work Order Number: {{this.task.workOrder.workOrderNumber}}
        </v-col>
        <v-col cols="12" sm="12" style="height:35px">
          Work Order Task Number: {{this.task.taskNumber}}
        </v-col>
        <v-col cols="12" sm="12" style="height:35px; overflow:hidden">
          Address: {{this.task.address}}
        </v-col>
        <v-col cols="12" sm="12" style="height:75px">
          <v-dialog
            ref="startDialog"
            :return-value.sync="startDate"
            persistent
            width="290px"
            v-model="startDateModal"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startDate"
                label="Start Date"
                readonly
                v-on="on"
               :rules="[checkDates() || 'Start date is invalid, must be less then end date or any scheduled days']"
              ></v-text-field>
            </template>
            <v-date-picker v-model="startDate" type="date" @input="$refs.startDialog.save(startDate)"
                           scrollable>
              <div class="flex-grow-1"></div>
              <v-btn text color="accent" @click="startDateModal = false">Cancel</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <div class="flex-grow-1"></div>
        <v-col cols="12" sm="12" style="height:75px">
          <v-dialog
            ref="endDialog"
            v-model="endDateModal"
            :return-value.sync="completionDate"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="completionDate"
                label="Completion Date"
                 :rules="[checkDates() || 'End date is invalid, must be greater then start date or any scheduled days']"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="completionDate"
              type="date"
              @input="$refs.endDialog.save(completionDate)"
              scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="accent" @click="endDateModal = false">Cancel</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <div class="flex-grow-1"></div>

        <div class="flex-grow-1"></div>
        <v-col cols="12" sm="12" style="height:75px">
          <v-text-field
            placeholder
            v-model="task.duration"
            label="Duration"
          ></v-text-field>
        </v-col>
      </v-card-text>
      <v-alert v-if="this.preUpdateError !=null" justify-center color="error" dark>
        <v-icon size="20" dark>warning</v-icon>
        {{this.preUpdateError}}
      </v-alert>
      <v-card-actions style="text-align:center">
        <v-col sm="12">
          <v-btn block depressed color="accent" @click="update">Save</v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'edit-task-condensed',
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    adminFlag: true,
    startDateModal: false,
    endDateModal: false,
    preUpdateError: null,
    disabled: false
    }),
  methods: {
    ...mapActions({
      updateTask: 'workOrderTask/updateTask',
      createDay: 'schedule/createScheduledDay'
    }),
    returnName () {
      var name = 'Work Order'
      if (this.selectedTask != null) {
        name = this.task.name
      }
      return name
    },
    async update () {
      this.disabled = true
      try {
        this.checkForErrors()
        if (!this.preUpdateError) {
          await this.updateTask(this.task)
        }
        if (!this.error && !this.preUpdateError) {
          this.toggle()
          await this.addScheduleDay()
        }
      } catch (error) {
        this.preUpdateError = error.message
      }
      this.disabled = false
    },
    checkForErrors () {
      let endDate = new Date(this.completionDate)
      let startDate = new Date(this.startDate)
      if (endDate < startDate) {
        this.preUpdateError = 'Error! Start Date After Completion Date'
        this.disabled = true
      } else if (!endDate && !startDate) {
        this.preUpdateError = 'Error! Please Enter a Date'
        this.disabled = true
      } else if (!this.checkDates()) {
        this.preUpdateError = 'Error! Schedule days must fall within start & completion days. Go to the calendar to check the scheduled days.'
         this.disabled = true
      } else {
        this.preUpdateError = null
        this.disabled = false
      }


    },
    checkDates() {
      let valid = true

      let endDate = new Date(this.completionDate.slice(0, 10))
      let startDate = new Date(this.startDate.slice(0, 10))

          this.schedule.forEach(d => {
            let day = new Date(d.start.slice(0, 10))

            if (startDate > day) { valid = false }
            if (endDate < day) { valid =  false}
          })

      return valid
    },
    async addScheduleDay() {
      if (this.schedule.length === 0) {
        if (this.task.startDate !== null && this.task.completionDate !== null) {
          let schedule = {}
          if (this.task.startDate.slice(0, 10) === this.task.completionDate.slice(0, 10)) {            
            schedule = {
              note: null,
              crewId: null,
              start: this.task.startDate.slice(0,10)+ 'T' + this.getDefaultTimes.start,
              end: this.task.startDate.slice(0, 10) + 'T' + this.getDefaultTimes.end,
              workOrderTaskId: this.task.id
            }
          } else {
            schedule = {
              note: null,
              crewId: null,
              start: this.task.startDate.slice(0,10)+'T'+ this.getDefaultTimes.none,
              end: this.task.completionDate.slice(0, 10) +'T'+ this.getDefaultTimes.none,
              workOrderTaskId: this.task.id
            }
          }
          await this.createDay(schedule)
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      error: 'workOrderTask/error',
      selectedTaskColor: 'workOrderTask/selectedTaskColor',
      schedule: 'schedule/scheduleByTask',
      getDefaultTimes: 'schedule/getDefaultTimes'
    }),
    startDate: {
      get () {
        return this.task.startDate.slice(0, 10) === '0001-01-01' ? new Date().toISOString().slice(0, 10) : this.task.startDate.slice(0, 10)
      },
      set (value) {
        this.task.startDate = value
      }
    },
    completionDate: {
      get () {
        return this.task.completionDate.slice(0, 10) === '0001-01-01' ? new Date().toISOString().slice(0, 10) : this.task.completionDate.slice(0, 10)
      },
      set (value) {
        this.task.completionDate = value
      }
    }
  }
}
</script>
